import { Component, OnInit } from "@angular/core";
import { AbstractFormWidgetComponent } from "../abstract-form-widget/abstract-form-widget.component";
import { SearchService } from "../../../search/search.service";
import { SearchEvent } from "../../../search/models/search-event";
import {NEW_SEARCH_EVENT,NEW_ROW_EVENT,PAGE_OVERFLOW_EVENT} from "../../../search/search-constants";
import { ReceiptButtonService } from "../../../services/receipt/receipt-button.service";
import { ReceiptDataService } from "../../../services/receipt/receipt-data.service";

@Component({
    selector: "asn-status-tracking-widget",
    templateUrl: "./asn-status-tracking-widget.html",
    styleUrls: ["./asn-status-tracking-widget.css"],
})
export class AsnStatusTrackingWidgetComponent extends AbstractFormWidgetComponent implements OnInit
{
    public searchService: SearchService;
    public dataService: ReceiptDataService;
    public buttonService: ReceiptButtonService;
    public ngOnInit() {
        this.buttonService = <ReceiptButtonService>(
        this.pageConfig.buttonService
    );
    this.initializeWidget();
    this.searchService.receiveEvent().subscribe((event: SearchEvent) => {
    this.buttonService.initializeButtonsForPage(this.cellDataMap, "details");
    if (event.type === NEW_SEARCH_EVENT && this.searchService.getMetadata()) {
        // For NEW_SEARCH_EVENT, the Details Data Table will be displayed
        this.pageConfig.isDetailSectionLoaded = true;
    } else if (event.type === NEW_ROW_EVENT) {
        const newRow = event.selectedRow.cells;
        // on addrow, documentNo is to be autopopulated as the mbol key value.
        if (newRow['documentNo']) {
            newRow['documentNo'].cVal =
                this.dataService.primaryDataMap['receiptKey'].cVal;
        }
        // For NEW_ROW_EVENT
        // for new row event the search service should also be passed to distinguish between the two tables
//        this.dataService.handleAddNewItem(event, this.searchService);
    } else if (event.type === PAGE_OVERFLOW_EVENT) {
        // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
        // page on success
        this.searchService.setNewPageEventInProgress(true);
        this.buttonService.performButtonActions("Save");
    }
    });
}

protected initializeWidget() {
    // this is not to be loaded from the primary data map, hence initializing it
    // this.pageConfig.cellDataMap = {};
    super.initializeWidget();
    this.searchService = this.dataService.getSearchServiceForColumnGroup(this.widgetConfig.id);
    this.searchService.displayMode = "V";
    this.searchService.clearSearchStatus();
    if (this.dataService.displayMode === "C") {
        this.searchService.displayMode = "C";
    } else {
        this.searchService.setSearchCriteria({
        conditions: [
            {
            mandatory: false,
            clauses: [
                {
                column: "documentNo",
                operation: "=",
                value: this.dataService.getPrimarySelectedDocument(),
                logicalOperation: null,
                },
            ],
            logicalOperation: null,
            },
        ],
        });
        this.searchService.performSearch();
    }
}

  // realigns the widget
    public realignWidget() {
    //  this.propertyList = this.preparePropertyGrid(this.widgetConfig.propertyList, this.getCellsPerRow());
    }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/widget/asn-status-tracking-widget/asn-status-tracking-widget.ts